import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { QUERY } from '@/constants/common';
import { AdKind } from '@/api/types/common.types';
import { useUrlAndHashFromPath } from '@/hooks/useUrlAndHashFromPath';

const PROMOTION_TYPE_BY_HASH: Partial<Record<string, AdKind>> = {
  [QUERY.modalFeature]: AdKind.Premium,
  [QUERY.modalVip]: AdKind.Vipped,
  [QUERY.modalBump]: AdKind.Bumped,
};

export function usePromotionOpener(openPromo: (type: AdKind) => void) {
  const router = useRouter();
  const { url, hash } = useUrlAndHashFromPath();
  const promotionType = hash ? PROMOTION_TYPE_BY_HASH[hash] : undefined;

  useEffect(() => {
    if (!promotionType) return;

    openPromo(promotionType);
    router.replace(url, undefined, { scroll: false });
  }, [hash, promotionType]);
}
